export const getApiToken = (firebaseStore) =>
  firebaseStore?.auth?.stsTokenManager?.accessToken ?? '';

export const buildFiltersQuery = (filters = {}, filtersStore) => {
  let query = '';

  if (filters.jobTitles?.length) {
    const mids = filters.jobTitles.reduce(
      (acc, title) =>
        `${acc}title_mids=${encodeURIComponent(title.value.toLowerCase())}&`,
      '',
    );
    const names = filters.jobTitles.reduce(
      (acc, title) =>
        `${acc}title_names=${encodeURIComponent(title.label.toLowerCase())}&`,
      '',
    );
    query += `${mids}${names}`;
  }

  if (filters.locations?.length) {
    const mids = filters.locations.reduce(
      (acc, location) =>
        `${acc}location_mids=${encodeURIComponent(location.label)}&`,
      '',
    );
    const placeIds = filters.locations.reduce(
      (acc, location) =>
        `${acc}location_place_ids=${encodeURIComponent(location.value)}&`,
      '',
    );

    query += `${mids}${placeIds}`;
  }

  if (filters.skills?.length) {
    const mids = filters.skills.reduce(
      (acc, skill) =>
        `${acc}skills_mids=${encodeURIComponent(skill.value.toLowerCase())}&`,
      '',
    );

    const names = filters.skills.reduce(
      (acc, skill) =>
        `${acc}skills_names=${encodeURIComponent(skill.label.toLowerCase())}&`,
      '',
    );

    query += `${mids}${names}`;
  }

  if (filters.statuses?.length) {
    const statuses = filters.statuses.reduce(
      (acc, status) =>
        `${acc}employment_status=${encodeURIComponent(status.value)}&`,
      '',
    );

    query += `${statuses}`;
  }

  // if (filtersStore.signInMethod.candidatePortal) {
  //   query += 'with_signup=1&';
  // }

  if (filters.keywords?.length) {
    const keywords = filters.keywords.reduce(
      (acc, keyword) => `${acc}keywords=${encodeURIComponent(keyword.value)}&`,
      '',
    );

    query += `${keywords}`;
  }

  if (filters.contactData?.length) {
    const contactData = filters.contactData.reduce((acc, contact) => {
      if (contact.value === 'email') {
        return `${acc}has_email=true&`;
      }
      if (contact.value === 'phone') {
        return `${acc}has_phone=true&`;
      }
      return acc;
    }, '');

    query += `${contactData}`;
  }

  if (filtersStore.job) {
    query += `job_id=${filtersStore.job}&`;
  }

  return query;
};
